<article class="bo-auth-feature">
  <div class="bo-auth-feature__icon" [style.color]="iconColor()">
    <ng-content select="[icon]"></ng-content>
  </div>
  <div>
    <h3 class="bo-auth-feature__title">{{ title() }}</h3>
    <p class="bo-auth-feature__description">{{ description() }}</p>
  </div>
</article>
